import React, { useEffect, useMemo } from "react";
import css from "@/components/Listing/ListingScreen/.module.scss";
import { usePath } from "@/contexts/path/path";
import Link from "next/link";
import { useQuery } from "@apollo/client";
import { GET_LAST_STAT } from "@/graphql/queries/statisitcal";
import { financialFormat, getSize, hasResidentialStats } from "@/lib/helpers";
import { useRouter } from "next/router";
import {
  trackClickResidentialIndicatorsBanner,
  trackViewResidentialIndicatorsBanner,
} from "@/lib/tracking/trackResidentialIndicatorEvents";
import Icon from "@/components/icon";

const DistrictStats = ({ listing }) => {
  const {
    category,
    residentialStatsConfig,
    district,
    updateContext,
    previousPath,
  } = usePath();

  const doesCategoryHaveStats = hasResidentialStats(
    category,
    residentialStatsConfig,
  );

  const router = useRouter();

  const size = useMemo(() => {
    return getSize(listing, category?.id);
  }, [listing, category?.id]);

  const { data, loading, error } = useQuery(GET_LAST_STAT, {
    skip: !doesCategoryHaveStats || !district?.id || size == null,
    variables: {
      district_id: district?.id,
      category: category.id,
      size,
    },
  });

  useEffect(() => {
    if (
      doesCategoryHaveStats &&
      !loading &&
      !error &&
      data?.ResidentialIndicators?.getLastStat
    ) {
      trackViewResidentialIndicatorsBanner({
        listingType: category?.ga_listing_type,
        category: category?.en,
        source: previousPath,
      });
    }
  }, [
    doesCategoryHaveStats,
    loading,
    error,
    data?.ResidentialIndicators?.getLastStat,
  ]);

  if (
    !doesCategoryHaveStats ||
    loading ||
    error ||
    !data?.ResidentialIndicators?.getLastStat
  )
    return null;

  const label = data?.ResidentialIndicators?.getLastStat?.message_ar;
  const value = data?.ResidentialIndicators?.getLastStat?.value;
  const periodType = data?.ResidentialIndicators?.getLastStat?.period_type;

  const getStatsLink = () => {
    const pathParts = ["الإحصائيات-العقارية"];
    const currentPath = router.asPath.split("?")[0].split("/");
    const newPath = [
      ...pathParts,
      ...currentPath.slice(0, currentPath.length - 1),
      "المؤشرات",
    ].join("/");

    return `${newPath}?size=${size}&href=pdp`;
  };

  const getPeriodType = (period) => {
    switch (period) {
      case "monthly":
        return "شهرياً";
      case "annually":
        return "سنوياً";
      case "quarterly":
        return "ربع سنوي";
      case "semiannually":
        return "نصف سنوي";
      default:
        return "سنوي";
    }
  };

  return (
    <>
      {/*<h4>معلومات {district?.name}</h4>*/}
      <div
        className={css.statsSection}
        style={{ marginTop: "-4px", marginBottom: "8px" }}
      >
        <Link
          className={`${css.card} ${css.statsCard}`}
          href={getStatsLink()}
          onClick={(e) => {
            e.preventDefault();
            trackClickResidentialIndicatorsBanner({
              listingType: category?.ga_listing_type,
              category: category?.en,
              source: previousPath,
            });
            updateContext({
              mode: "residential_stats_filters",
              isStatResults: true,
            });
            router.push(getStatsLink());
          }}
        >
          <div className={css.right}>
            <Icon
              className={css.main}
              asSVG
              width={20}
              height={20}
              name="v1/bar-line-chart"
            />
            <div>
              <p className={css.label}>{label}</p>
              <p className={css.value}>{`${financialFormat(value)} ريال ${
                listing?.title.includes("للبيع")
                  ? ""
                  : getPeriodType(periodType)
              }`}</p>
            </div>
          </div>
          <div className={css.left}>
            {/*<p className={css.displayMoreText}>عرض المزيد</p>*/}
            <Icon width={25} height={25} name="leftArrow-searches" />
          </div>
        </Link>
        {/*<div className={css.disclaimerSection}>*/}
        {/*  <Icon asSVG width={12} height={12} name="attention" />*/}
        {/*  <p>بناءً على بيانات الإعلانات المنشورة في منصة عقار</p>*/}
        {/*</div>*/}
      </div>
    </>
  );
};

export default DistrictStats;
